import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaSplit from './VaSplit.vue'

export const VaSplit = withConfigTransport(_VaSplit)
